import React from "react";
import MessageInput from "../../components/MessageInput/MessageInput";
import ChatWindow from "../../components/ChatWindow/ChatWindow";

const IntelligentDocManagement: React.FC = () => {

    return (
        <>
            <ChatWindow />
            <MessageInput isIDMUpload={true} currentModule="idm" />
        </>
    )
}

export default IntelligentDocManagement
